export default [  
  {
    path: '/brands',
    name: 'brands',
    component: () => import('@/views/modules/brands/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Brands List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Brands' }
      ]
    },
    children:[
      {
        path: '/brands/create',
        name: 'brands-create',
        component: () => import('@/views/modules/brands/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Brand Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Brands', link: '/brands' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/brands/:id/edit',
        props: true,
        name: 'brands-edit',
        component: () => import('@/views/modules/brands/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Brands Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Brand',  to: { name: "brands-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: '/brands/:id/show',
        props: true,
        name: 'brands-show',
        component: () => import('@/views/modules/brands/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Brands Details',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Brands',  to: { name: "brands" } },
            { text: 'Details' }
          ]
        }
      },
    
    ]
  },
 
]